import script from "./PilotChip.vue?vue&type=script&setup=true&lang=js"
export * from "./PilotChip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__